module.exports = __webpack_public_path__ + "static/Logo_jandj-7a2b00653837809c3f0e88ead648db6b.png";